import Badge from "./ui/Badge"

const ImageSearchBadge = () => {
  return <Badge className="w-[80px]">Generative</Badge>
}

export default ImageSearchBadge
